import { useAuth } from '@opendoor/auth-fe/context';
import { useQuery } from '@tanstack/react-query';
import { requestZeusFromBrowser } from 'components/api/zeusBrowserClient';

import type { HubBuyerTourFeedbacksQuery } from './__generated__/hub-buyer-data.zeus';
import { HubBuyerTourFeedbacksDocument } from './__generated__/hub-buyer-data.zeus';

export type HubBuyingTourFeedback =
  HubBuyerTourFeedbacksQuery['customerAccount']['buyer']['tourFeedbacks'][number];

export function useHubTourFeedbacks() {
  const { authentication } = useAuth();
  const customerUuid =
    authentication.state === 'authenticated' ? authentication.user.customerUuid : null;
  return useQuery({
    queryKey: ['hub', 'tour-feedback', customerUuid],
    enabled: customerUuid !== null,
    meta: { captureErrorContext: 'HubBuyerTourFeedbacks' },
    queryFn: async ({ signal }) => {
      const result = await requestZeusFromBrowser(HubBuyerTourFeedbacksDocument, {}, signal);
      return result.customerAccount.buyer.tourFeedbacks;
    },
  });
}
